import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../supabase/supabaseClient";

function ProtectedRoute({ children }) {
    const [loading, setLoading] = useState(true);
    const [authed, setAuthed] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkAuth = async () => {
            try {
                // Use getSession() (local) instead of getUser() (network).
                // getUser() can fail silently (error returned) during transient connectivity
                // and make the UI look "signed out" even when a session exists.
                const { data } = await supabase.auth.getSession();
                if (!isMounted) return;
                setAuthed(!!data?.session?.user);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkAuth();

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            if (!isMounted) return;
            setAuthed(!!session?.user);
            setLoading(false);
        });

        return () => {
            isMounted = false;
            subscription?.unsubscribe();
        };
    }, []);

    if (loading) {
        return null; // Or a small spinner
    }

    return authed ? children : <Navigate to="/login" replace />;
}

export default ProtectedRoute;
